module.exports = __webpack_public_path__ + "static/prince-sodhi-cf40747e6aa9022141fdbd29c07d4e35.jpg";